export default {"src":"/_next/static/media/back_icon.12ff82c6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};